import React, { useState, useEffect } from 'react'
import * as helper from "../../utils/helper";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Row, Col } from 'react-bootstrap';
import InputText from "../InputText";
import InputSelect from "../InputSelect";
import { logout } from "../../redux/actions/logoutAction";
import { loading } from "../../redux/actions/loadingAction";
import * as API from "../../utils/apis";

function ModalVaccineType({ show, close, save, mode, idEdit }) {
    const user = useSelector(state => state.login.result);
    const initialForm = {
        vaccine_id: "",
        vaccine_name: "",
        diseaseId: "",
        animalId: "",
        status: "",
        createDate: "",
        updateDate: "",

        checkShow: false
    };
    const initInvalidMsg = {
        vaccine_id: "",
        vaccine_name: "",
        diseaseId: "",
        animalId: "",
        status: "",
    };
    const selectStatusList = [
        { value: 1, label: "ใช้งาน" },
        { value: 2, label: "ไม่ใช้งาน" },
    ];
    const initAnimalIdSelectValue = [];
    const selectAnimalIdList = [];
    const initDiagnosisSelectValue = [];
    const selectDiagnosisList = [];
    const initStatusSelectValue = [];

    const dispatch = useDispatch();
    const history = useHistory();

    const [form, setForm] = useState(initialForm);
    const [invalid, setInvalid] = useState(initInvalidMsg);
    const [animalIdSelectValue, setAnimalIdSelectValue] = useState(initAnimalIdSelectValue)
    const [animalIdList, setAnimalList] = useState(selectAnimalIdList)

    const [checkDiseaseList, setCheckDiseaseList] = useState(false)

    const [diseaseSelectValue, setDiseaseSelectValue] = useState(initDiagnosisSelectValue)
    const [diseaseList, setDiseaseList] = useState(selectDiagnosisList)
    const [statusSelectValue, setStatusSelectValue] = useState(initStatusSelectValue);
    const [statusList, setStatusList] = useState(selectStatusList);

    useEffect(async () => {
        if (mode === "add") {
            await setForm(initialForm)
            setStatusSelectValue([])
            setAnimalIdSelectValue([])
            setDiseaseSelectValue([])
        }
    }, [mode])

    useEffect(async () => {
        if (mode === "edit" && !form.checkShow) {
            await getVaccineTypeById(idEdit)
        }
    }, [mode, idEdit, show, form.vaccine_name, form.status, form.animalId, diseaseList])

    useEffect(async () => {
        await getAnimal()
    }, [])

    const addInvalid = (element, message) => {
        invalid[element] = message;
        setInvalid({ ...invalid });
    };

    const removeInvalid = (element) => {
        invalid[element] = "";
        setInvalid({ ...invalid });
    };

    const validate = () => {
        let validated = true;

        if (form.vaccine_name === "") {
            addInvalid("vaccine_name", "โปรดระบุอาการป่วย");
            validated = false;
        }

        if (form.animalId === "") {
            addInvalid("animalId", "กรุณาเลือกชนิดสัตว์");
            validated = false;
        }

        if (form.diseaseId === "") {
            addInvalid("diseaseId", "กรุณาเลือกชนิดโรค");
            validated = false;
        }

        if (form.status === "") {
            addInvalid("status", "กรุณาเลือกสถานะ");
            validated = false;
        }

        return validated;
    };

    const handleClose = () => {
        close()
        setInvalid(initInvalidMsg)
        setForm(initialForm)
        setStatusSelectValue([])
        setAnimalIdSelectValue([])
        setDiseaseSelectValue([])
    }

    const toConfrim = async () => {
        if (validate()) {
            await save({ vaccine: form, mode: mode });
            handleClose();
        }
    };

    const getAnimal = async () => {
        try {
            const response = await API.getAnimal("", 1);
            const data = await response.data;
            if (response.status === 200) {
                let animalArray = [];
                data.content.forEach(element => {
                    animalArray.push({
                        value: element.id, label: element.name,
                    });
                });
                setAnimalList(animalArray);
            }
        } catch (error) {
            console.log(error)
        }
    }

    const getDiseaseType = async (idAnimal) => {
        try {
            const response = await API.getDiseaseType(idAnimal);
            const data = await response.data;
            if (response.status === 200) {
                let diseaseArray = [];
                data.content.forEach(element => {
                    diseaseArray.push({
                        value: element.id, label: element.name,
                    });
                });
                setDiseaseList(diseaseArray);
                setCheckDiseaseList(true)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const getVaccineTypeById = async (id) => {
        let dataSy;
        try {
            const response = await API.getVaccineTypeById(id);
            if (response.status === 200) {
                dataSy = response.data;
            }
        } catch (error) {
            dispatch(loading(false))
            if (error.response && error.response.status === 401) {
                dispatch(logout({ history }))
            }
            console.log(error)
        }

        if (dataSy) {
            if (dataSy.statusId) {
                let statusSelect = statusList.find(item => item.value === dataSy.statusId);
                setStatusSelectValue(statusSelect);
            }

            if (dataSy.animalTypeId) {
                let animalIdSelect = await animalIdList.find(item => item.value === dataSy.animalTypeId);
                setAnimalIdSelectValue(animalIdSelect);

                if (diseaseList.length == 0) {
                    await getDiseaseType(dataSy.animalTypeId);
                }
            }

            if (dataSy.diseaseTypeId) {
                let diseaseSelect = await diseaseList.find(item => item.value === dataSy.diseaseTypeId);
                setDiseaseSelectValue(diseaseSelect);
            }
        }

        // console.log("dataSy.diseaseTypeId", dataSy.diseaseTypeId);

        setForm({
            ...form,
            vaccine_id: dataSy.id,
            vaccine_name: dataSy.name,
            animalId: dataSy.animalTypeId,
            diseaseId: dataSy.diseaseTypeId,
            status: dataSy.statusId,
            createDate: dataSy.createDate,
            updateDate: dataSy.updateDate

        })
    }

    const selectValueAnimal = (value) => {
        setAnimalIdSelectValue([{ value: value.value, label: value.label }])
        setForm({ ...form, animalId: value.value, chooseSelect: true })
        setDiseaseSelectValue([])
        getDiseaseType(value.value);
    }

    return (
        <Modal
            show={show}
            size="lg"
            onHide={() => { handleClose() }}
            centered
        >
            <Modal.Header closeButton className="pb-2 ">
                <Modal.Title className="mt-2">
                    <h5><strong>เพิ่มอาการป่วย</strong></h5>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-3">
                <div className="">
                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                        <li className="nav-item tab">
                            <a className="nav-link active" id="data-tab" data-toggle="tab" href="#data" role="tab" aria-controls="data" aria-selected="true">ข้อมูลพื้นฐาน</a>
                        </li>
                        <li className={invalid.status ? "nav-item-invalid tab" : "nav-item tab"}>
                            <a className="nav-link" id="status-tab" data-toggle="tab" href="#status" role="tab" aria-controls="status" aria-selected="false">สถานะ</a>
                        </li>
                    </ul>
                    <div className="tab-content" id="myTabContent">
                        <div className="tab-pane fade show active card-tab" id="data" role="tabpanel" aria-labelledby="data-tab">
                            <Row>
                                <Col lg={6} md={6} sm={12} xs={12}>
                                    <InputText type="text" title="ชนิดวัคซีน" idName="vaccine_name" value={form.vaccine_name} star={false}
                                        placeholder="โปรดระบุ" classLabel="normal"
                                        handleChange={(value) => setForm({ ...form, vaccine_name: value, checkShow: true })}
                                        handleInvalid={() => removeInvalid("vaccine_name")}
                                        invalid={invalid.vaccine_name}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6} md={6} sm={12} xs={12}>
                                    <InputSelect
                                        title="ชนิดสัตว์" star={false} placeholder="กรุณาเลือก" idName="title" classLabel="normal"
                                        selectValue={animalIdSelectValue} optionsList={animalIdList}
                                        handleChange={(value) => {
                                            selectValueAnimal(value)
                                            setForm({ ...form, animalId: value.value })
                                        }}
                                        handleInvalid={() => removeInvalid("animalId")}
                                        invalid={invalid.animalId}
                                    />
                                </Col>
                                <Col lg={6} md={6} sm={12} xs={12}>
                                    <InputSelect
                                        title="ชนิดโรค" star={false} placeholder="กรุณาเลือก" idName="title" classLabel="normal"
                                        selectValue={diseaseSelectValue} optionsList={diseaseList}
                                        handleChange={(value) => {
                                            setDiseaseSelectValue(value)
                                            setForm({ ...form, diseaseId: value.value, checkShow: true })
                                        }}
                                        handleInvalid={() => removeInvalid("diseaseId")}
                                        invalid={invalid.diseaseId}
                                    />
                                </Col>
                            </Row>
                        </div>
                        <div className="tab-pane fade card-tab" id="status" role="tabpanel" aria-labelledby="status-tab">
                            <Row>
                                <Col lg={3} md={6} sm={12} xs={12}>
                                    <InputSelect
                                        title="สถานะ" star={false} placeholder="กรุณาเลือก" idName="title" classLabel="normal"
                                        selectValue={statusSelectValue} optionsList={statusList}
                                        handleChange={(value) => {
                                            setStatusSelectValue(value)
                                            setForm({ ...form, status: value.value, checkShow: true })
                                        }}
                                        handleInvalid={() => removeInvalid("status")}
                                        invalid={invalid.status}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={3} md={6} sm={12} xs={12}>
                                    <div className="d-flex align-items-center text-gray mb-0 font12 mt-3 ml-2">
                                        <p className="mr-4">วันที่บันทึกข้อมูล</p>
                                        <p>{form.createDate ? helper.momentDate(form.createDate, "th", "short") : '-'}</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={3} md={6} sm={12} xs={12}>
                                    <div className="d-flex align-items-center text-gray mb-0 font12 ml-2">
                                        <p className="mr-3" >วันที่ปรับปรุงข้อมูล</p>
                                        <p>{form.updateDate ? helper.momentDate(form.updateDate, "th", "short") : '-'}</p>
                                    </div>
                                </Col>

                            </Row>
                        </div>

                    </div>
                </div>
                <div className="mr-2 mt-3 mb-2">
                    <div className="text-right py-2">
                        <button className="btn btn-danger px-4 mr-2" onClick={() => handleClose()}>ยกเลิก</button>
                        <button className="btn btn-success px-4" onClick={() => toConfrim()} disabled={user?.userGroup.mupdate === "n" && mode === "edit"}>บันทึก</button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default ModalVaccineType
